// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* /settings: the panel in a readable column. The page shell and its scroll
   region are the monitor page's (../monitor/MonitorPage.module.css). */

.lccfsNSW0UpHh5e0ISS9 {
  max-width: 960px;
  margin: 0 auto;
}

.Mn1zBqXe1Cc42RyaH1cb {
  margin: 4px 0 14px;
  font-size: 20px;
  font-weight: 600;
  color: var(--curio-text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/pages/settings/SettingsPage.module.css"],"names":[],"mappings":"AAAA;uEACuE;;AAEvE;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC","sourcesContent":["/* /settings: the panel in a readable column. The page shell and its scroll\n   region are the monitor page's (../monitor/MonitorPage.module.css). */\n\n.page {\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.title {\n  margin: 4px 0 14px;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `lccfsNSW0UpHh5e0ISS9`,
	"title": `Mn1zBqXe1Cc42RyaH1cb`
};
export default ___CSS_LOADER_EXPORT___;
